import axios from "axios";

export const sizeChart = () => {
    document.addEventListener('DOMContentLoaded', () => {
        let url = document.URL;
        const baseIndex = url.indexOf('/products/');
        const baseUrl = url.substring(0, baseIndex);
        let currentVariant = "";
    
        const productSize = document.querySelector('#product_size_variation');
        if ( productSize ) {
            redirectUrl(productSize, baseUrl, currentVariant);
        }

        const adopterSize = document.querySelector('#applewatch_adopter_variation');
        if ( adopterSize ) {
            redirectUrl(adopterSize, baseUrl, currentVariant);
        }
    })
}

const redirectUrl = (sizeElement, baseurl, currentVariant) => {
    if ( sizeElement ) {
        let variant_id = "";
        let productUrl = "";
        const oldSelected = sizeElement.selectedIndex;
        sizeElement.addEventListener('change', async () => {

            if (document.querySelector('variant-option-value')) {
                currentVariant = document.querySelector('variant-option-value').textContent;
            }

            const selectedIndex = sizeElement.selectedIndex;

            sizeElement.options[oldSelected].defaultSelected = false;
            sizeElement.options[selectedIndex].setAttribute("selected", "selected");

            let url = `${baseurl}${sizeElement.querySelector('option[selected]').value}.js`;
            const productObject = await getProductJson(url);

            const nextProduct = productObject.variants;
            nextProduct.forEach( element => {
                if ( element.title == currentVariant ) {
                    variant_id = element.id;
                    productUrl = `${baseurl}${sizeElement.querySelector('option[selected]').value}?variant=${variant_id}`;
                    return;
                }
            });
            if ( productUrl == "" ) {
                productUrl = `${baseurl}${sizeElement.querySelector('option[selected]').value}`;
                window.location.replace( productUrl );
            } else {
                window.location.replace( productUrl );
            }
        })
    }
}

const getProductJson = async (url) => {
    try {
        const response = await axios({
          headers: {
            "Content-Type": "application/json"
          },
          method: 'GET',
          url: url
        });
        return response.data;
      } catch (error) {
        console.log(error);
        throw new Error("Failed to get product JSON.");
      }
}